export default __webpack_public_path__ + "static/media/icon8.ef6a1d74.svg";